@use '_snippets/form-label';
@use 'variables' as *;
@use 'src/components/cat-form-hint/cat-form-hint';
@use 'utils/color';
@use 'mixins' as *;

:host {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

input {
  font: inherit;
  margin: 0;
  min-width: 20rem;
  padding: 0.375rem 0;
  flex: 1 1 auto;
  border: none;
  outline: none;
  background: none;
  @include cat-ellipsis;

  .input-disabled & {
    cursor: not-allowed;
    color: cat-token('color.ui.font.muted');
  }

  &::placeholder {
    color: cat-token('color.ui.font.muted');
    opacity: 1;
  }

  /* stylelint-disable property-no-vendor-prefix */
  &:-webkit-autofill {
    &,
    &:hover,
    &:focus {
      -webkit-box-shadow: 0 0 0 9999px cat-token('color.ui.background.inputAutofill') inset;
    }
  }
  /* stylelint-enable property-no-vendor-prefix */
}

.input-wrapper {
  flex: 1 1 auto;
  display: flex;
  align-items: stretch;
  gap: 0.25rem;
  padding: 0.25rem 0.75rem;
  min-height: 2rem;
  background: cat-token('color.ui.background.input');
  border-radius: cat-border-radius('m');
  box-shadow: inset 0 0 0 1px rgb(var(--border-color));
  transition: box-shadow cat-token('time.transition.s') linear;
  --border-color: #{cat-token('color.ui.border.dark', $wrap: false)};
  flex-wrap: wrap;

  &.input-disabled {
    background: cat-token('color.ui.background.muted');
    cursor: not-allowed;
    color: cat-token('color.ui.font.muted');
  }

  &:not(.input-disabled):hover {
    box-shadow:
      inset 0 0 0 1px rgb(var(--border-color)),
      0 0 0 1px rgb(var(--border-color));
  }

  &:focus-within {
    outline: 2px solid cat-token('color.ui.border.focus');
    outline-offset: -1px;

    &:has(.clearable:focus) {
      outline: none;
    }
  }

  &.input-invalid {
    --border-color: #{cat-token('color.theme.danger.bg', 0.2, $wrap: false)};
  }

  /* stylelint-disable property-no-vendor-prefix */
  &:has(input:-webkit-autofill) {
    &,
    &:hover,
    &:focus {
      background-color: cat-token('color.ui.background.inputAutofill');
    }
  }
  /* stylelint-enable property-no-vendor-prefix */
}

.tag-pill {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem 0.5rem;
  background: cat-token('color.ui.background.muted');
  border-radius: cat-border-radius('s');
  white-space: nowrap;
  min-width: 0;

  > span {
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1 1 0;
  }

  > cat-button {
    margin-right: -0.25rem;
    margin-left: -0.25rem;
  }
}

.icon-suffix {
  align-self: center;
}

.input-inner-wrapper {
  flex: 1 1 auto;
  display: flex;
}
